import { useSearchParams } from "react-router-dom";

import ModalProductDetail from "@/components/modal/ProductModals/ModalProductDetail/ModalProductDetail";
import ModalProductPrice from "@/components/modal/ProductModals/ModalProductPrice/ModalProductPrice";

const PRODUCT_MODAL_COMPONENT_BY_ACTION = {
	detail: ModalProductDetail,
	price: ModalProductPrice,
};

const ProductModals = () => {
	const [searchParams] = useSearchParams();
	const productCode = searchParams.get("product");
	const productAction = searchParams.get("action");

	if (!productCode || !productAction) {
		return null;
	}

	const ProductModalComponent = PRODUCT_MODAL_COMPONENT_BY_ACTION[productAction];
	if (!ProductModalComponent) {
		return null;
	}

	return <ProductModalComponent />;
};

export default ProductModals;
